/**
 * 缓存说明:socket连接中获取到的各类信息的缓存
 */
import vm from './storeTools.js'

var basestate = {
	realTimeEvent: [], //实时事件列表
	pushMessage: [], //公告列表
	msgList: [], //消息列表
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getRealTimeEventList(state, getters) {
			return state.realTimeEvent
		},
		getPushMessage(state, getters) {
			return state.pushMessage
		},
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		addRealTimeEvent(state, realTimeEvent) {
			//倒序插入,新事件在前面
			state.realTimeEvent.unshift(realTimeEvent)
		},
		addPushMessage(state, message) {
			state.pushMessage.push(message)
		},
		addMsg(state, message) {
			try{
				if(!!message.eventtime){
					message.timeText = new Date(message.eventtime).formatByTime()
				}else if(!!message.time){
					message.timeText = new Date(message.time).formatByTime()
				}else{
					message.timeText = ''
				}
				message.unReaded = true
			}catch(e){
			}
			state.msgList.unshift(message)
			if (state.msgList.length > 100) {
				state.msgList.pop()
			}
		},
	}
});

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
